import styled from "styled-components";
import { Link } from "react-router-dom";
import { mobile } from "../responsive";
import { useEffect, useState } from "react";

const Container = styled.div`
  height: 30px;
  border-bottom: solid 0.5px lightgrey;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  padding: 1em;
  ${mobile({
    overflowX: "scroll",
    scrollbarWidth: "none",
    overflowY: "hidden",
    justifyContent: "start",
  })};
`;

const NavFlyout = styled.div`
  margin-top: 0px;
  border: solid 0.5px lightgrey;
  z-index: 999999999999 !important;
  position: absolute;
  background-color: rgba(249, 249, 249, 1);
`;

const FeaturedCategories = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 24px;
  align-items: center;
  text-align: center;
  a,
  span {
    font-weight: bold;
  }
  &:hover {
    color: #4339fa !important;
  }
  ul {
    display: flex;
  }
  li {
    align-items: center;
    text-align: center;
    border: 1px solid #000;
    border-radius: 24px;
    box-sizing: border-box;
    display: inline-flex;
    flex-direction: row;
    height: 48px;
    justify-content: center;
    margin-right: 9px;
    max-width: 180px;
    min-width: 80px;
    padding: 4px 24px;
    white-space: nowrap;
  }
`;
const Announcements = () => {
  const [display, setDisplay] = useState("");

  useEffect(() => {
    setDisplay(window.location.pathname.includes("Cart") ? "none" : "");
  }, []);
  return (
    <>
      <Container style={{ display: display }}>
        <FeaturedCategories>
          <ul>
            <li>
              <Link
                to="/products/diy-and-tools"
                style={{ textDecoration: "none", color: "#000" }}
              >
                {" "}
                Tool Hire
              </Link>
            </li>
            <li>
              <Link
                to="/products/womens-fashion/Designer%20Dresses"
                style={{ textDecoration: "none", color: "#000" }}
              >
                Rent Dresses
              </Link>
            </li>
            <li>
              <Link
                to="/products/electronics-and-photo/Cameras"
                style={{ textDecoration: "none", color: "#000" }}
              >
                {" "}
                Cameras
              </Link>
            </li>
            <li>
              <Link
                to="/products/toys-and-games"
                style={{ textDecoration: "none", color: "#000" }}
              >
                Toys
              </Link>
            </li>
            <li>
              <Link
                to="/products/video-games-and-consoles"
                style={{ textDecoration: "none", color: "#000" }}
              >
                Video Games
              </Link>
            </li>

            <li>
              <Link
                to="/products/womens-fashion/Designer%20Handbags"
                style={{ textDecoration: "none", color: "#000" }}
              >
                Handbags
              </Link>
            </li>

            <li>
              <Link
                to="/products/baby-equipment-clothes"
                style={{ textDecoration: "none", color: "#000" }}
              >
                Baby Equipment
              </Link>
            </li>

            <li>
              <Link
                to="/products/home-and-kitchen"
                style={{ textDecoration: "none", color: "#000" }}
              >
                Home & Kitchen
              </Link>
            </li>
            <li>
              <Link
                to="/all-categories"
                style={{ textDecoration: "none", color: "#000" }}
              >
                All Categories
              </Link>
            </li>
          </ul>
        </FeaturedCategories>
      </Container>
    </>
  );
};

export default Announcements;
